<div class="map" id="map"></div>
<div class="bottom-bar">
<ul>
  <li>Developed by <a href="https://audio-lab.org">Audiolab</a> using <a href="https://www.mapbox.com/mapbox-gl-js/">MapboxGL</a>
  <li><a href="/{{lang}}/">Home</a></li>
</ul>
</div>



// WEBPACK FOOTER //
// ./src/app/map-box/map-box.component.html